import "./css/style.scss";
import ReactDOM from "react-dom/client";
import NavBar from "./Components/NavBar.jsx";
import LoadingScreen from "./Components/LoadingScreen.jsx";
import Footer from "./Footer.jsx";
import Home from "./Home.jsx";
import Projects from "./Projects.jsx";
import Team from "./Team.jsx";
import Clients from "./Clients.jsx";
import { content } from "./content.js";

export default function App() {
  const scroll = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <LoadingScreen />
      <NavBar content={content.navbar} handleScroll={scroll} />
      <Home
        content={content.home}
        goDown={() => {
          scroll("projects");
        }}
      />
      <Projects content={content.projects} />
      <Team content={content.team} />
      <Clients id="clients" content={content.clients} />
      <Footer id="footer" content={content.footer} />
    </>
  );
}
